import { useNuxtApp } from '#app';
import { ref } from 'vue';
import { useStoreRoot } from '~/stores/abstract/root';
import type { Device } from '@nuxtjs/device/dist/runtime/types';

const widthMax = {
  mobile: 700,
  tablet: 1240,
};

export function usePlatform() {
  const nuxtApp = useNuxtApp();

  // Access device information from nuxt-device plugin
  const device = nuxtApp.$device as Device;

  // Reactive screen dimensions
  const screenWidth = ref(import.meta.browser ? window.innerWidth : NaN);
  const screenHeight = ref(import.meta.browser ? window.innerHeight : NaN);

  // Update screen dimensions on resize
  const updateScreenSize = () => {
    screenWidth.value = window.innerWidth;
    screenHeight.value = window.innerHeight;

    // @TODO: find a way to fix reactive from composable
    useStoreRoot().setScreen({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  // Optionally destructure or expose specific properties
  const isMobile = device?.isMobile;
  const isTablet =
    device?.isTablet ||
    (device?.isDesktop && !!screenWidth.value && screenWidth.value <= widthMax.tablet);

  const isDesktop = device?.isDesktop && !isTablet;
  const userAgent = device?.userAgent;

  return {
    device,
    isMobile,
    isDesktop,
    isTablet,
    userAgent,
    screenWidth,
    screenHeight,
    updateScreenSize,
  };
}
